import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import theme from "../../../theme";
import { NumberBlock } from "./NumberBlock";
import { OffersStatusBreakdown } from "../orderAPI";

type Props = {
  offers: OffersStatusBreakdown;
};

export const StatusOverviewBlock = ({ offers }: Props) => {
  const { t } = useTranslation("order");

  return (
    <Grid container>
      <Grid item container xs={10}>
        <Grid item xs={3}>
          <NumberBlock
            amount={offers?.workOffersOffered.toString()}
            amountColor={"black"}
            label={t("offered")}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberBlock
            amount={offers?.workOffersAccepted.toString()}
            amountColor={theme.palette.success.light}
            label={t("accepted")}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberBlock
            amount={offers?.workOffersDeclined.toString()}
            amountColor={theme.palette.error.light}
            label={t("declined")}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberBlock
            amount={offers?.workOffersNoResponse.toString()}
            amountColor={theme.palette.primary.main}
            label={t("noAnswer")}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
